import { InputHTMLAttributes } from 'react';

export function ToggleButton({
  ...rest
}: InputHTMLAttributes<HTMLInputElement>) {
  const { checked } = rest;

  return (
    <label
      className={`relative flex items-center cursor-pointer rounded-full w-8 h-5 transition
        duration-200 ease-out ${checked ? 'bg-success-300' : 'bg-neutral-500'}`}
    >
      <input type="checkbox" className="sr-only peer" {...rest} />

      <div
        className="absolute w-5 h-5 p-0.5 transition-all duration-200 ease-in-out left-0
          peer-checked:left-[calc(100%-theme(spacing.5))]"
      >
        <div className="w-full h-full bg-neutral-100 rounded-full" />
      </div>
    </label>
  );
}
